'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthSeedPayload(secret) {
  this.YE = null;
  this.YE = secret;
}
export { $c_Lpresto_types$TwoFactorAuthSeedPayload as $c_Lpresto_types$TwoFactorAuthSeedPayload };
$p = $c_Lpresto_types$TwoFactorAuthSeedPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthSeedPayload;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthSeedPayload() {
}
export { $h_Lpresto_types$TwoFactorAuthSeedPayload as $h_Lpresto_types$TwoFactorAuthSeedPayload };
$h_Lpresto_types$TwoFactorAuthSeedPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$TwoFactorAuthSeedPayload) && (this.YE === x$0.YE)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "TwoFactorAuthSeedPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.YE;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$TwoFactorAuthSeedPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kp)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuthSeedPayload as $isArrayOf_Lpresto_types$TwoFactorAuthSeedPayload };
var $d_Lpresto_types$TwoFactorAuthSeedPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthSeedPayload, "presto.types$TwoFactorAuthSeedPayload", ({
  kp: 1,
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuthSeedPayload as $d_Lpresto_types$TwoFactorAuthSeedPayload };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Seed-Payload.js.map
